import { render, staticRenderFns } from "./UnqualifiedProject.vue?vue&type=template&id=46bc996c&scoped=true"
import script from "./UnqualifiedProject.vue?vue&type=script&lang=js"
export * from "./UnqualifiedProject.vue?vue&type=script&lang=js"
import style0 from "./UnqualifiedProject.vue?vue&type=style&index=0&id=46bc996c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc996c",
  null
  
)

export default component.exports